import { createFileRoute } from "@tanstack/react-router";
import { InvoicesPage } from "@/app/connect/pages/invoices";

type InvoicesSearchParams = {
	provider_id?: string;
};

function cleanId(value: unknown): string | undefined {
	if (typeof value === "number") return String(value);
	if (typeof value === "string") {
		const cleaned = value.replace(/^["']|["']$/g, "");
		return cleaned || undefined;
	}
	return undefined;
}

export const Route = createFileRoute("/connect/invoices")({
	validateSearch: (search: Record<string, unknown>): InvoicesSearchParams => ({
		provider_id: cleanId(search.provider_id),
	}),
	component: InvoicesPage,
});
